document.addEventListener('DOMContentLoaded', function () {
  // Duplicate marquee content for seamless scroll
  document.querySelectorAll('.marquee-track').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('nav.primary');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Product page: sync variant <select> to hidden variant id inputs on Buy Now / Add to Cart forms
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var variantId = select.value;
      document.querySelectorAll('[data-variant-id-input]').forEach(function (input) {
        input.value = variantId;
      });
    });
  });
});
